import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { bannerImages } from "../../assets/dummyData";

const BannerImageSlider = () => {
  return (
    <div style={{ width: "100%", maxWidth: "100vw", margin: "30px auto" }}>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        pagination={{
          type: "bullets",
          clickable: true,
        }}
        spaceBetween={0}
        slidesPerView={1}
        style={{
          width: "100%",
          height: "200px",
          paddingBottom: "40px",
        }}
      >
        {bannerImages.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Product Detail ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BannerImageSlider;
